<template>
  <div>
    <v-layout>
      <v-flex>
        <ag-grid-vue
          style="width: 1350px; height: 240px; margin: 10px 30px 10px 30px"
          class="ag-theme-balham center-box elevation-2"
          :columnDefs="columnDefs"
          :rowData="rowData"
          :gridOptions="gridOptions"
          :rowSelection="rowSelection"
          :enableCellChangeFlash="true"
          @selection-changed="onSelectionChanged"
        >
        </ag-grid-vue>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { taskService } from "@/services/task.service.js";
import { appSettings } from "@/common/app.settings.js";

export default {
  name: "DataByStaff",
  props: {
    staffCriteria: Object,
  },
  data: function () {
    return {
      columnDefs: null,
      rowData: null,
      selectedRowData: null,
      loading: false,
      rowSelection: null,
      gridApi: null,
      results: null,
      totalItems: null,
    };
  },
  components: {
    AgGridVue,
  },
  beforeMount() {
    this.columnDefs = [
      {
        field: "DAY_START",
        headerName: "DAY_START",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
      },
      {
        field: "DAY_END",
        headerName: "DAY_END",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
      },
      {
        field: "STAFF_ID",
        headerName: "STAFF_ID",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
      },
      {
        field: "STAFF_NAME",
        headerName: "STAFF_NAME",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
      },
      {
        field: "MANAGER",
        headerName: "MANAGER",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
      },
      {
        field: "SUPERVISOR",
        headerName: "SUPERVISOR",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
      },
      {
        field: "AREA",
        headerName: "AREA",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
      },
      {
        field: "REGION",
        headerName: "REGION",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
      },
      {
        field: "SEGMENT",
        headerName: "SEGMENT",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
      },
      {
        field: "PSU",
        headerName: "PSU",
        width: 120,
        resizable: true,
        sortable: true,
        filter: true,
      },
    ];

    this.rowData = [
      {
        DAY_START: "01/02/2003",
        DAY_END: "01/03/2003",
        STAFF_ID: "12345",
        STAFF_NAME: "mike",
        MANAGER: "nathan",
        SUPERVISOR: "john",
        AREA: "28888",
        REGION: "west",
        SEGMENT: "large",
        PSU: "unknown"
      },
    ];

		// commented these out, not sure why they are here
    // this.suspectTasksCount = 1;
    // this.totalTasksCount = 3;
  },
  onSelectionChanged() {
    this.selectedRowData = this.gridApi.getSelectedRows();
    if (Array.isArray(this.selectedRowData) && this.selectedRowData.length) {
      this.rightRowData = this.selectedRowData[0].caseList;
      this.assignStaffId = this.selectedRowData[0].idStaff;
    }
  },
};
</script>


<style scoped>
@import "../../node_modules/ag-grid-community/styles/ag-grid.css";
@import "../../node_modules/ag-grid-community/styles/ag-theme-alpine.css";

div {
  color: brown;
}
</style>
